import { render, staticRenderFns } from "./faq_client.vue?vue&type=template&id=2d97b84f&scoped=true&"
import script from "./faq_client.vue?vue&type=script&lang=js&"
export * from "./faq_client.vue?vue&type=script&lang=js&"
import style1 from "./faq_client.vue?vue&type=style&index=1&id=2d97b84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97b84f",
  null
  
)

export default component.exports